module.exports = __webpack_public_path__ + "static/media/gameSpacePets.7b7e8a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameSpacePets.png
// module id = 2507
// module chunks = 0